var map = {
	"./01_trade_info.json": "dF/+",
	"./02_last_price.json": "GtO6",
	"./03_mark_price.json": "BwZb",
	"./04_depth.json": "fcau",
	"./05_bookTicker.json": "KrjX",
	"./06_kline.json": "sLxw",
	"./07_24hr_ticker.json": "ywsQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NCXQ";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/market \.json$
// module id = NCXQ
// module chunks = 3